
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgImageFiber = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 17.158A23.644 23.644 0 0 1 22 10a23.644 23.644 0 0 1 17 7.158M12.158 25.21c2.34-2.732 5.88-4.473 9.842-4.473 3.962 0 7.503 1.741 9.842 4.474",
  stroke: "#000",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 33.996a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}))));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M5 17.158A23.644 23.644 0 0 1 22 10a23.644 23.644 0 0 1 17 7.158M12.158 25.21c2.34-2.732 5.88-4.473 9.842-4.473 3.962 0 7.503 1.741 9.842 4.474\" stroke=\"#000\" stroke-width=\"3\" stroke-linecap=\"round\"/>\r\n        <path d=\"M22 33.996a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4z\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/image-fiber.9574d038a469a450c41dd9cb994e049e.svg"),
        {
          React: SvgImageFiber,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      